/**
 * nativeApp.ts — Capacitor 네이티브 앱(안드로이드 래퍼) 안에서 실행 중인지 판별.
 * 네이티브에서는 백버튼을 웹의 Navigation API(예측 뒤로가기 한계) 대신 Capacitor 의
 * 네이티브 `backButton` 이벤트로 처리한다(App.tsx BackGuard). 일반 브라우저/PWA 에선 false.
 *
 * 원격 로딩(server.url)로 띄운 경우에도 Capacitor 가 window.Capacitor 브리지를 주입하므로,
 * 번들 @capacitor/core 의 isNativePlatform() 과 주입된 브리지 양쪽을 모두 검사해 신뢰성 확보.
 */
import { Capacitor } from "@capacitor/core";

export function isNativeApp(): boolean {
  try {
    if (Capacitor.isNativePlatform()) return true;
  } catch {
    /* ignore */
  }
  try {
    const cap = (
      window as unknown as {
        Capacitor?: {
          isNativePlatform?: () => boolean;
          getPlatform?: () => string;
          isNative?: boolean;
        };
      }
    ).Capacitor;
    if (!cap) return false;
    if (typeof cap.isNativePlatform === "function" && cap.isNativePlatform()) return true;
    if (cap.isNative === true) return true;
    if (typeof cap.getPlatform === "function" && cap.getPlatform() !== "web") return true;
  } catch {
    /* ignore */
  }
  return false;
}
